import { render } from "./Lecciones.vue?vue&type=template&id=5c7225d4"
import script from "./Lecciones.vue?vue&type=script&lang=js"
export * from "./Lecciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__